import { CalcDecimal, moneyString } from "./decimal.js";

export const MONEY_ROUNDING_MODE = "ROUND_HALF_UP_TO_2_DECIMALS" as const;

export const DM2016_SERVICE_ROUNDING_POLICY_ID =
  "dm2016-service-sum-raw-bands-then-half-up-cent-v1" as const;

export const DM2016_SUMMARY_ROUNDING_POLICY_IDS = {
  aggregate_raw: "dm2016-summary-aggregate-raw-then-half-up-cent-v1",
  sum_rounded_lines: "dm2016-summary-sum-rounded-service-lines-v1",
} as const;

export const DM2016_POST_COMPENSATION_ROUNDING_POLICY_ID =
  "dm2016-bim-expenses-round-each-stage-half-up-cent-v1" as const;

export const QUOTE_FINANCIALS_ROUNDING_POLICY_ID =
  "quote-financials-round-each-stage-half-up-cent-v1" as const;

export type Dm2016SummaryRoundingPolicy =
  keyof typeof DM2016_SUMMARY_ROUNDING_POLICY_IDS;

export function roundedMoneyDecimal(
  value: InstanceType<typeof CalcDecimal>,
): InstanceType<typeof CalcDecimal> {
  return new CalcDecimal(moneyString(value));
}
